import { render } from "./LayoutNoSidebar.vue?vue&type=template&id=4b54222a"
import script from "./LayoutNoSidebar.vue?vue&type=script&lang=js"
export * from "./LayoutNoSidebar.vue?vue&type=script&lang=js"

import "./LayoutNoSidebar.vue?vue&type=style&index=0&id=4b54222a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__